import type { FaireProductEntity } from "../../entity_types/product";

export const p_fnmevy4pz2: FaireProductEntity = {
  token: "p_fnmevy4pz2",
  type: "product",
  name: "LOVE Mid Graphic Sweatshirt",
  brandToken: "b_ebyk25ji57",
  brandName: "OAT COLLECTIVE",
  imageUrl:
    "https://cdn.faire.com/fastly/f5b6ffe0d9657c838ac86a3e022b53ee17f314e0e3a09fbdb4cf83b88904b627.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9145761ea982e2f3f674e5ae636c669a57a9d8aec8a14cd5bfb413cd4d302cde.jpeg",
    "https://cdn.faire.com/fastly/2aa346749e57582fc47b85f94dc0ab9d59771b737c42d340430c6bc508dea984.jpeg",
    "https://cdn.faire.com/fastly/3708519e658ab9d0487e9aac9aabc13661f44237a83810bb075338f404b8a4f5.jpeg",
    "https://cdn.faire.com/fastly/6fc92d502122154f4e6cb01776fc0c92c4f3c7b443a95b14d34ddf6f91866ba9.jpeg",
    "https://cdn.faire.com/fastly/731257db6d66b03fbd36761503ddf6edaeda01fa074cf51a2467f0f1ecdda5f2.jpeg",
    "https://cdn.faire.com/fastly/4cc892cc3eea92a08f13c5db508143fa9c25ea08d0b6f2ee59ab6f74c54a3651.jpeg",
    "https://cdn.faire.com/fastly/c38f3c9ed924c43a0acf7ff6ec327bf4bd9fa2f48153f89e5783f072760a99b4.jpeg",
    "https://cdn.faire.com/fastly/843d443f10ce6114f0da14e6baf8de2dd7f626135b5a2c58f50a01c7d0b13345.jpeg",
    "https://cdn.faire.com/fastly/699599d9c60b5076fb35d5052414fee1e39cabfd243283ad455409128565eff9.jpeg",
    "https://cdn.faire.com/fastly/9601d443bb7a7b3f73e09fbbbae6046bb4336bbd17c3b3e83ff8305fdb795e3b.jpeg",
    "https://cdn.faire.com/fastly/1dfc5c8ab5ad28be141a46573f01ca974a134e5babc353aa087a98962af29ae2.jpeg",
    "https://cdn.faire.com/fastly/667a2a0e8d1138c684df536333f30f5505ce3b9a4a38dad263110841f3751f7d.jpeg",
  ],
  priceDollars: 33.07,
  description:
    "LOVE  Mid Cropped length Graphic Fleece Pullover Relaxed Fit.\n\n\nDetails:\n\n-Mid Cropped Length \n\n-Fold-able Longer Sleeve Length\n\n-Comfortable Boxy Fit\n\n-Spun from plush sponge fleece fabric\n\n-Remarkably soft pullover\n\n-Featuring ribbed cuffs and waistband, a crew neck\n\n-Exclusive Oat Collective Label and Design",
  tags: [],
  msrpDollars: 63.38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:45.582Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
